import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    downloadUrl: String,
    whatsappUrl: String
  }

  connect() {
    this.element.addEventListener("click", this.send.bind(this))
  }

  send(event) {
    event.preventDefault()

    // Download the document
    const link = document.createElement("a")
    link.href = this.downloadUrlValue
    link.click()

    // Open WhatsApp after a small delay to ensure download starts
    setTimeout(() => {
      window.open(this.whatsappUrlValue, "_blank")
    }, 500)
  }
}
